import React from 'react'
import {useCookieConsent} from '../../app/context/CookieConsentContext'
import {useAuth} from '../../app/modules/auth'
import styled from 'styled-components'

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
`

const Card = styled.div`
  background: #fff;
  border-radius: 20px;
  border: 1px solid #e0e0e0;
  padding: 40px 32px 32px;
  max-width: 420px;
  width: 92%;
  text-align: center;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
`

const CloseButton = styled.button`
  position: absolute;
  top: 14px;
  right: 16px;
  background: none;
  border: none;
  font-size: 22px;
  color: #999;
  cursor: pointer;
  padding: 4px 8px;
  line-height: 1;
  transition: color 0.2s;

  &:hover {
    color: #333;
  }
`

const CookieIconWrapper = styled.div`
  margin: 0 auto 20px;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px;
`

const Description = styled.p`
  font-size: 15px;
  color: #888;
  line-height: 1.6;
  margin: 0 0 28px;
  padding: 0 8px;
`

const AcceptAllButton = styled.button`
  width: 100%;
  padding: 16px;
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  background: #a3a23a;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s;
  margin-bottom: 12px;

  &:hover {
    background: #8e8d32;
  }
`

const NecessaryButton = styled.button`
  width: 100%;
  padding: 16px;
  font-size: 17px;
  font-weight: 600;
  color: #333;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
    border-color: #ccc;
  }
`

const CookieIcon: React.FC = () => (
  <svg width="90" height="90" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Cream/beige bite background */}
    <rect x="55" y="5" width="30" height="30" rx="6" fill="#f0ead6" />
    {/* Cookie body with bite */}
    <path
      d="M50 6C27 6 8 25 8 50c0 25 19 44 42 44s42-19 42-44c0-3-.3-5.5-.8-8a5 5 0 01-4.2 2.2 5 5 0 01-5-5c0-1.2.4-2.3 1.1-3.2a5 5 0 01-4-4.9c0-1.5.7-2.9 1.7-3.8C75.5 17.5 64 6 50 6z"
      fill="none"
      stroke="#a3a23a"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Chocolate chip dots */}
    <circle cx="32" cy="40" r="4.5" fill="#a3a23a" />
    <circle cx="45" cy="58" r="4" fill="#a3a23a" />
    <circle cx="55" cy="40" r="3.5" fill="#a3a23a" />
    <circle cx="38" cy="65" r="3" fill="#a3a23a" />
    <circle cx="60" cy="58" r="3" fill="#a3a23a" />
    <circle cx="28" cy="55" r="3" fill="#a3a23a" />
    <circle cx="48" cy="44" r="2.5" fill="#a3a23a" />
  </svg>
)

const CookieConsentBanner: React.FC = () => {
  const {consentGiven, acceptAll, acceptNecessary} = useCookieConsent()
  const {currentUser} = useAuth()
  const isInterpreter = currentUser?.result?.userType === 'INTERPRETER'

  if (consentGiven || !currentUser || !isInterpreter) return null

  return (
    <Overlay>
      <Card>
        <CloseButton onClick={acceptNecessary} aria-label="Close">
          &times;
        </CloseButton>
        <CookieIconWrapper>
          <CookieIcon />
        </CookieIconWrapper>
        <Title>Cookie Settings</Title>
        <Description>
          We use cookies to ensure you get the best experience on our platform.
        </Description>
        <AcceptAllButton onClick={acceptAll}>Accept All Cookies</AcceptAllButton>
        <NecessaryButton onClick={acceptNecessary}>Necessary Only</NecessaryButton>
      </Card>
    </Overlay>
  )
}

export default CookieConsentBanner
